import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { AnimatePresence } from "framer-motion";
import { API, cores, IA_SUGESTOES, fromInputDate, perfilLabel, COLUNAS_KANBAN, haptic, isHoje } from "../../constants";
import ModalDetalhes from "../modals/ModalDetalhes";
import ModalAcao from "../modals/ModalAcao";
import AbaRelatorios from "../sections/AbaRelatorios";
import AlertaCarrossel from "../ui/AlertaCarrossel";
import SkeletonKanban from "../ui/SkeletonKanban";
import AIProcessing from "../ui/AIProcessing";
import GerenciarUsuarios from "./GerenciarUsuarios";

export default function Dashboard({ usuario, fazenda, onVoltarFazendas, onLogout }) {
  const [tarefas, setTarefas] = useState([]);
  const [alertas, setAlertas] = useState([]);
  const [culturasFazenda, setCulturasFazenda] = useState([]);
  const [operadoresFazenda, setOperadoresFazenda] = useState([]);
  const [carregandoTarefas, setCarregandoTarefas] = useState(true);
  const [texto, setTexto] = useState("");
  const [processandoIA, setProcessandoIA] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [aba, setAba] = useState("tarefas");
  const [tarefaDetalhes, setTarefaDetalhes] = useState(null);
  const [tarefaSelecionada, setTarefaSelecionada] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [carregandoPdf, setCarregandoPdf] = useState(false);
  const [recomendacoesPdf, setRecomendacoesPdf] = useState([]);
  const [resumoVisita, setResumoVisita] = useState("");
  const [filtrocultura, setFiltrocultura] = useState("geral");
  const [filtroOperador, setFiltroOperador] = useState("todos");
  const [mostrarConcluidas, setMostrarConcluidas] = useState(false);
  const [gerenciandoUsuarios, setGerenciandoUsuarios] = useState(false);
  const [sugestaoIdx, setSugestaoIdx] = useState(0);
  const [prazoNovaRec, setPrazoNovaRec] = useState("");
  const kanbanRef = useRef(null);

  const isDono = usuario.perfil === "dono";
  const isAdm = usuario.perfil === "adm";
  const isOperador = usuario.perfil === "operador";
  const isConsultor = usuario.perfil === "consultor";
  const isOperacional = ["adm", "gestor", "operador"].includes(usuario.perfil);
  const podeFiltrarOperador = ["adm", "gestor"].includes(usuario.perfil);
  const podeVerRelatorios = ["adm", "gestor", "dono"].includes(usuario.perfil);
  const podeCriarRecomendacao = () => { if (isAdm) return true; if (isConsultor) return true; if (usuario.perfil === "gestor") return localStorage.getItem("pode_criar_tarefas") !== "false"; return false; };
  const podeNovaRecomendacao = podeCriarRecomendacao() && !isDono && !isOperador;

  useEffect(() => { const t = setInterval(() => setSugestaoIdx(i => (i + 1) % IA_SUGESTOES.length), 3000); return () => clearInterval(t); }, []);

  const buscarTarefas = async () => {
    setCarregandoTarefas(true);
    try {
      let url = `${API}/tarefas?fazenda_id=${fazenda.id}`;
      if (isOperador) url += `&operador_id=${usuario.id}`;
      if (isConsultor) url += `&consultor_id=${usuario.id}`;
      const res = await axios.get(url);
      setTarefas(res.data);
      if (!isDono) { try { const resAlertas = await axios.get(`${API}/alertas?fazenda_id=${fazenda.id}`); setAlertas(resAlertas.data); } catch { setAlertas([]); } }
    } catch (err) {
      console.error("[Dashboard] Erro ao buscar tarefas:", err);
    } finally {
      setCarregandoTarefas(false);
    }
  };

  const buscarCulturas = async () => { try { const res = await axios.get(`${API}/fazendas/${fazenda.id}/culturas`); setCulturasFazenda(res.data.culturas); } catch { setCulturasFazenda([]); } };
  const buscarOperadores = async () => { try { const res = await axios.get(`${API}/usuarios/${fazenda.id}/operadores`); setOperadoresFazenda(res.data); } catch { setOperadoresFazenda([]); } };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buscarTarefas(); buscarCulturas(); if (podeFiltrarOperador) buscarOperadores(); }, [fazenda.id]);

  const enviarRecomendacao = async () => {
    if (!texto.trim()) return;
    setProcessandoIA(true); setMensagem("");
    try {
      const res = await axios.post(`${API}/recomendacao`, {
        texto, fazenda_id: fazenda.id, criado_por_id: usuario.id,
        prazo: prazoNovaRec ? fromInputDate(prazoNovaRec) : undefined
      });
      setMensagem("✅ Tarefa criada: " + res.data.dados.titulo);
      setTexto(""); setPrazoNovaRec(""); buscarTarefas(); haptic([10, 50, 100]);
    } catch { setMensagem("❌ Erro ao processar. Tente novamente."); }
    setProcessandoIA(false);
  };

  const enviarPdf = async () => {
    if (!pdfFile) return;
    setCarregandoPdf(true); setRecomendacoesPdf([]); setResumoVisita("");
    try {
      const formData = new FormData();
      formData.append("arquivo", pdfFile);
      const res = await axios.post(`${API}/pdf/processar?fazenda_id=${fazenda.id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      setRecomendacoesPdf(res.data.recomendacoes); setResumoVisita(res.data.resumo_visita);
    } catch { alert("Erro ao processar PDF."); }
    setCarregandoPdf(false);
  };

  const confirmarPdf = async () => {
    setCarregandoPdf(true);
    try {
      await axios.post(`${API}/pdf/confirmar`, { recomendacoes: recomendacoesPdf, fazenda_id: fazenda.id, criado_por_id: usuario.id });
      setRecomendacoesPdf([]); setResumoVisita(""); setPdfFile(null); buscarTarefas(); setAba("tarefas");
    } catch { alert("Erro ao confirmar."); }
    setCarregandoPdf(false);
  };

  const parsePrazo = prazo => {
    try { if (!prazo || prazo === "A definir") return new Date("2099-12-31"); const [d, m, a] = prazo.split("/"); return new Date(`${a}-${m}-${d}`); } catch { return new Date("2099-12-31"); }
  };

  const naoplanejadas = tarefas.filter(t => t.status === "nao_planejada").length;
  const planejadas = tarefas.filter(t => t.status === "planejada").length;
  const atrasadas = tarefas.filter(t => t.status === "atrasada").length;
  const emExecucao = tarefas.filter(t => t.status === "em_execucao").length;
  const pausadas = tarefas.filter(t => t.status === "pausada").length;
  const concluidas = tarefas.filter(t => t.status === "concluida").length;
  const culturas = ["geral", ...new Set(tarefas.map(t => t.cultura).filter(Boolean))];

  const tarefasConcluidas = tarefas
    .filter(t => t.status === "concluida")
    .filter(t => filtrocultura === "geral" || t.cultura === filtrocultura)
    .filter(t => filtroOperador === "todos" || t.delegado_para_id === parseInt(filtroOperador))
    .sort((a, b) => new Date(b.concluido_em) - new Date(a.concluido_em));

  if (gerenciandoUsuarios) return <GerenciarUsuarios usuario={usuario} fazenda={fazenda} onVoltar={() => setGerenciandoUsuarios(false)} />;

  const CardKanban = ({ t }) => {
    const hoje = isHoje(t.prazo);
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl p-3 border border-gray-100 dark:border-gray-700 hover:shadow-md transition cursor-pointer active:scale-95"
        onClick={() => setTarefaDetalhes(t)}>
        <div className="h-0.5 rounded-full mb-2 w-full" style={{ backgroundColor: cores[t.prioridade] }} />
        {hoje && <span className="inline-flex items-center text-xs bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 px-2 py-0.5 rounded-full font-bold mb-1.5">📅 Hoje</span>}
        <p className="text-xs font-semibold text-gray-800 dark:text-white leading-snug mb-1.5">{t.titulo}</p>
        {t.descricao && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-2 leading-relaxed"
            style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
            {t.descricao}
          </p>
        )}
        <div className="flex flex-wrap gap-1 mb-1.5">
          <span className="text-xs bg-blue-50 dark:bg-blue-900/20 text-blue-600 px-1.5 py-0.5 rounded-full">🌾 {t.cultura}</span>
        </div>
        <div className="flex items-center justify-between mt-1">
          <p className="text-xs text-gray-400 dark:text-gray-500">📅 {t.prazo}</p>
          {isOperacional && (
            <button onClick={e => { e.stopPropagation(); setTarefaSelecionada(t); }}
              className="text-xs bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 font-semibold px-2 py-1 rounded-lg hover:bg-green-100 transition min-h-11 flex items-center">⚡</button>
          )}
        </div>
        {t.delegado_para_nome && <p className="text-xs text-green-600 mt-1 font-medium">👷 {t.delegado_para_nome.split(" ")[0]}</p>}
        {t.criado_por_perfil === "consultor" && t.criado_por_nome && <p className="text-xs text-green-600 mt-0.5">🌿 {t.criado_por_nome.split(" ")[0]}</p>}
      </div>
    );
  };

  const stats = [
    { label: "Atrasadas", valor: atrasadas, cor: "text-red-600", bg: "bg-red-50 dark:bg-red-900/20" },
    { label: "Execução", valor: emExecucao, cor: "text-blue-600", bg: "bg-blue-50 dark:bg-blue-900/20" },
    { label: "Planejadas", valor: planejadas, cor: "text-blue-600", bg: "bg-blue-50 dark:bg-blue-900/20" },
    { label: "Pausadas", valor: pausadas, cor: "text-red-600", bg: "bg-red-50 dark:bg-red-900/20" },
    { label: "Concluídas", valor: concluidas, cor: "text-green-600", bg: "bg-green-50 dark:bg-green-900/20" },
    { label: "Não planej.", valor: naoplanejadas, cor: "text-gray-600", bg: "bg-gray-50 dark:bg-gray-800" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <AnimatePresence>
        {tarefaDetalhes && !tarefaSelecionada && (
          <ModalDetalhes tarefa={tarefaDetalhes} perfilUsuario={usuario.perfil}
            onFechar={() => setTarefaDetalhes(null)}
            onGerenciar={() => { setTarefaSelecionada(tarefaDetalhes); setTarefaDetalhes(null); }}
            onAtualizar={buscarTarefas} />
        )}
        {tarefaSelecionada && (
          <ModalAcao tarefa={tarefaSelecionada}
            onFechar={() => { setTarefaSelecionada(null); buscarTarefas(); }}
            onAtualizar={buscarTarefas} nomeUsuario={usuario.nome} perfilUsuario={usuario.perfil}
            culturasFazenda={culturasFazenda} fazendaId={fazenda.id} />
        )}
      </AnimatePresence>

      <header className="bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 px-4 py-3 sticky top-0 z-10">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button onClick={onVoltarFazendas} className="flex items-center gap-1.5 text-xs text-green-700 dark:text-green-400 font-semibold px-3 py-2 rounded-xl bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 hover:bg-green-100 transition min-h-11">← Fazendas</button>
            <div>
              <h1 className="text-sm font-bold text-gray-900 dark:text-white leading-tight">{fazenda.nome}</h1>
              <p className="text-xs text-gray-500 dark:text-gray-400">{perfilLabel[usuario.perfil]} · {usuario.nome.split(" ")[0]}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {isAdm && <button onClick={() => setGerenciandoUsuarios(true)} className="text-xs text-gray-500 dark:text-gray-400 font-medium px-3 py-2 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 transition min-h-11">👥</button>}
            <button onClick={onLogout} className="text-xs text-gray-500 dark:text-gray-400 font-medium px-3 py-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition min-h-11">Sair</button>
          </div>
        </div>
      </header>

      <div className="bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 px-4 py-2.5">
        <div className="max-w-6xl mx-auto">
          <div className="flex gap-2 overflow-x-auto pb-0.5">
            {stats.map((s, i) => (
              <div key={i} className={`flex-shrink-0 px-3 py-2 rounded-xl ${s.bg}`}>
                <p className={`text-lg font-bold ${s.cor}`}>{s.valor}</p>
                <p className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {alertas.length > 0 && !isDono && <AlertaCarrossel alertas={alertas} />}

      {isDono && (
        <div className="max-w-6xl mx-auto px-4 pt-3">
          <div className="p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-xl flex items-center gap-2">
            <span>👑</span>
            <p className="text-xs text-amber-800 dark:text-amber-300 font-medium">Visão do Dono — toque em qualquer tarefa para ver detalhes e histórico.</p>
          </div>
        </div>
      )}

      {/* Abas — sem Dashboard */}
      <div className="bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 sticky top-14 z-10">
        <div className="max-w-6xl mx-auto px-4 flex gap-0 overflow-x-auto">
          {[
            { id: "tarefas", label: isConsultor ? "📋 Minhas rec." : "⊞ Kanban" },
            ...(podeVerRelatorios ? [{ id: "relatorios", label: "📈 Relatórios" }] : []),
            ...(podeNovaRecomendacao ? [{ id: "nova", label: "✨ Nova rec." }] : []),
          ].map(a => (
            <button key={a.id} onClick={() => setAba(a.id)}
              className={`flex-shrink-0 px-4 py-3 text-xs font-semibold border-b-2 transition whitespace-nowrap min-h-11 ${aba === a.id ? "border-green-600 text-green-700 dark:text-green-400" : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700"}`}>
              {a.label}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-4">

        {aba === "relatorios" && podeVerRelatorios && <AbaRelatorios fazenda={fazenda} usuario={usuario} />}

        {aba === "nova" && podeNovaRecomendacao && (
          <div className="space-y-4">
            <div className="bg-white dark:bg-gray-900 rounded-2xl p-5 border border-gray-100 dark:border-gray-800">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 bg-green-100 dark:bg-green-900/30 rounded-xl flex items-center justify-center">✨</div>
                <div><p className="text-sm font-bold text-gray-900 dark:text-white">Nova recomendação via IA</p><p className="text-xs text-gray-500 dark:text-gray-400">A IA estrutura automaticamente em tarefa</p></div>
              </div>
              <textarea value={texto} onChange={e => setTexto(e.target.value)} disabled={processandoIA}
                placeholder={IA_SUGESTOES[sugestaoIdx]} rows={4}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-green-500 resize-none transition placeholder:text-gray-300 dark:placeholder:text-gray-600" />
              {/* Campo de prazo com calendário */}
              <div className="mt-3 mb-3">
                <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">📅 Prazo (opcional)</label>
                <input type="date" value={prazoNovaRec} onChange={e => setPrazoNovaRec(e.target.value)}
                  className="w-full mt-1.5 px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 dark:bg-gray-800 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-green-500 transition" />
              </div>
              <div className="mb-3">
                <p className="text-xs text-gray-400 font-medium">💡 Sugestões:</p>
                <div className="flex gap-1.5 mt-1.5 flex-wrap">
                  {["Aplicar defensivo", "Planejar adubação", "Verificar irrigação", "Análise de solo"].map(s => (
                    <button key={s} onClick={() => setTexto(s)} className="text-xs bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 px-2.5 py-1 rounded-full hover:bg-green-100 transition min-h-11">{s}</button>
                  ))}
                </div>
              </div>
              <button onClick={enviarRecomendacao} disabled={processandoIA || !texto.trim()}
                className="w-full bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white font-semibold py-3 rounded-xl text-sm transition min-h-11">
                {processandoIA ? "Processando..." : "✨ Processar com IA →"}
              </button>
              {processandoIA && <AIProcessing />}
              {mensagem && <p className={`mt-3 text-sm font-medium ${mensagem.includes("✅") ? "text-green-600" : "text-red-600"}`}>{mensagem}</p>}
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl p-5 border border-gray-100 dark:border-gray-800">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 bg-blue-100 dark:bg-blue-900/30 rounded-xl flex items-center justify-center">📄</div>
                <div><p className="text-sm font-bold text-gray-900 dark:text-white">Importar PDF</p><p className="text-xs text-gray-500 dark:text-gray-400">A IA extrai recomendações do relatório</p></div>
              </div>
              <label className="block border-2 border-dashed border-gray-200 dark:border-gray-700 rounded-xl p-6 text-center hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/10 transition cursor-pointer">
                <input type="file" accept=".pdf" onChange={e => setPdfFile(e.target.files[0])} className="hidden" />
                <svg className="w-8 h-8 mx-auto mb-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" /></svg>
                <p className="text-sm font-medium text-gray-600 dark:text-gray-300">{pdfFile ? pdfFile.name : "Clique para selecionar o PDF"}</p>
                <p className="text-xs text-gray-400 mt-1">Laudos técnicos, relatórios de visita</p>
              </label>
              {pdfFile && <button onClick={enviarPdf} disabled={carregandoPdf} className="w-full mt-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-semibold py-3 rounded-xl text-sm transition min-h-11">{carregandoPdf ? "Analisando com IA..." : "Analisar PDF →"}</button>}
            </div>

            {recomendacoesPdf.length > 0 && (
              <div className="bg-white dark:bg-gray-900 rounded-2xl p-5 border border-gray-100 dark:border-gray-800">
                <h2 className="text-sm font-bold text-gray-900 dark:text-white mb-1">✅ Revisar recomendações</h2>
                {resumoVisita && <p className="text-xs text-gray-500 mb-4 p-3 bg-gray-50 dark:bg-gray-800 rounded-xl">{resumoVisita}</p>}
                <div className="space-y-3 mb-4">
                  {recomendacoesPdf.map((rec, i) => (
                    <div key={i} className="p-3 rounded-xl border border-gray-100 dark:border-gray-700 flex gap-3">
                      <div className="flex-1">
                        <p className="text-sm font-semibold text-gray-900 dark:text-white">{rec.titulo}</p>
                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{rec.descricao}</p>
                        <div className="flex gap-1.5 mt-1.5"><span className="text-xs bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full">🌾 {rec.cultura}</span><span className="text-xs font-medium" style={{ color: cores[rec.prioridade] }}>● {rec.prioridade}</span></div>
                      </div>
                      <button onClick={() => setRecomendacoesPdf(prev => prev.filter((_, idx) => idx !== i))} className="text-xs bg-red-50 text-red-600 px-2.5 py-1.5 rounded-lg min-h-11 min-w-11 flex items-center justify-center">✕</button>
                    </div>
                  ))}
                </div>
                <button onClick={confirmarPdf} disabled={carregandoPdf} className="w-full bg-green-600 text-white font-semibold py-3 rounded-xl text-sm min-h-11">✅ Confirmar {recomendacoesPdf.length} recomendação(ões)</button>
              </div>
            )}
          </div>
        )}

        {aba === "tarefas" && (
          <div>
            {isOperador && <div className="p-3 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-xl mb-3 text-xs text-green-700 dark:text-green-400 font-medium">👷 Exibindo apenas as tarefas delegadas para você</div>}
            {isConsultor && <div className="p-3 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-xl mb-3 text-xs text-green-700 dark:text-green-400 font-medium">🌿 Exibindo apenas as recomendações que você lançou</div>}

            {podeFiltrarOperador && operadoresFazenda.length > 0 && (
              <div className="flex gap-2 mb-2 overflow-x-auto pb-1">
                <span className="text-xs text-gray-500 dark:text-gray-400 font-semibold self-center flex-shrink-0">👷</span>
                {[{ id: "todos", label: "Todos" }, ...operadoresFazenda.map(op => ({ id: String(op.id), label: op.nome.split(" ")[0] }))].map(op => (
                  <button key={op.id} onClick={() => setFiltroOperador(op.id)}
                    className={`flex-shrink-0 text-xs font-semibold px-3 py-1.5 rounded-full border transition min-h-11 ${filtroOperador === op.id ? "bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-900 border-gray-800" : "bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 border-gray-200 dark:border-gray-600"}`}>{op.label}</button>
                ))}
              </div>
            )}

            <div className="flex gap-2 mb-3 overflow-x-auto pb-1">
              {culturas.map(cultura => {
                const total = cultura === "geral" ? tarefas.length : tarefas.filter(t => t.cultura === cultura).length;
                return (
                  <button key={cultura} onClick={() => setFiltrocultura(cultura)}
                    className={`flex-shrink-0 text-xs font-semibold px-3 py-1.5 rounded-full border transition min-h-11 ${filtrocultura === cultura ? "bg-green-600 text-white border-green-600" : "bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 border-gray-200 dark:border-gray-600 hover:border-green-300"}`}>
                    {cultura === "geral" ? `🌐 Geral (${total})` : `🌾 ${cultura} (${total})`}
                  </button>
                );
              })}
            </div>

            {carregandoTarefas ? <SkeletonKanban /> : (
              <div>
                <div ref={kanbanRef} className="flex gap-4 pb-4"
                  style={{ overflowX: "auto", scrollSnapType: "x mandatory", WebkitOverflowScrolling: "touch" }}>
                  {COLUNAS_KANBAN.map(coluna => {
                    const tarefasColuna = tarefas
                      .filter(t => t.status === coluna.status)
                      .filter(t => filtrocultura === "geral" || t.cultura === filtrocultura)
                      .filter(t => filtroOperador === "todos" || t.delegado_para_id === parseInt(filtroOperador))
                      .sort((a, b) => {
                        if (coluna.status === "planejada") {
                          const aHoje = isHoje(a.prazo) ? 0 : 1;
                          const bHoje = isHoje(b.prazo) ? 0 : 1;
                          if (aHoje !== bHoje) return aHoje - bHoje;
                        }
                        return parsePrazo(a.prazo) - parsePrazo(b.prazo);
                      });
                    return (
                      <div key={coluna.status} className="flex-shrink-0" style={{ width: "260px", scrollSnapAlign: "start" }}>
                        <div className={`flex items-center justify-between px-3 py-2.5 rounded-t-xl border ${coluna.bg} ${coluna.border} border-b-0`}>
                          <span className={`text-xs font-bold ${coluna.text}`}>{coluna.emoji} {coluna.label}</span>
                          <span className={`text-xs font-bold px-1.5 py-0.5 rounded-full bg-white ${coluna.text}`}>{tarefasColuna.length}</span>
                        </div>
                        <div className={`border ${coluna.border} border-t-0 rounded-b-xl p-2 min-h-48 bg-gray-50 dark:bg-gray-800/50 space-y-2`}>
                          {tarefasColuna.length === 0 ? <p className="text-xs text-gray-300 dark:text-gray-600 text-center pt-8">Nenhuma tarefa</p> : tarefasColuna.map(t => <CardKanban key={t.id} t={t} />)}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="mt-2">
                  <button onClick={() => setMostrarConcluidas(!mostrarConcluidas)}
                    className="w-full flex items-center justify-between px-4 py-3 bg-white dark:bg-gray-900 rounded-xl border border-gray-100 dark:border-gray-800 text-xs text-gray-500 dark:text-gray-400 font-semibold hover:bg-gray-50 dark:hover:bg-gray-800 transition min-h-11">
                    <span>✅ Concluídas ({tarefasConcluidas.length})</span>
                    <span>{mostrarConcluidas ? "▼" : "▶"}</span>
                  </button>
                  {mostrarConcluidas && tarefasConcluidas.length > 0 && (
                    <div className="mt-2 flex gap-4 overflow-x-auto pb-2" style={{ scrollSnapType: "x mandatory" }}>
                      {tarefasConcluidas.map(t => (
                        <div key={t.id} className="flex-shrink-0 w-64" style={{ scrollSnapAlign: "start" }}>
                          <div className="bg-white dark:bg-gray-800 rounded-xl p-3 border border-gray-100 dark:border-gray-700 cursor-pointer hover:shadow-sm transition" onClick={() => setTarefaDetalhes(t)}>
                            <div className="h-0.5 bg-green-400 rounded-full mb-2" />
                            <p className="text-xs font-semibold text-gray-800 dark:text-white mb-1">{t.titulo}</p>
                            {t.descricao && <p className="text-xs text-gray-400 mb-1.5" style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{t.descricao}</p>}
                            <p className="text-xs text-green-600">✅ {t.concluido_em ? new Date(t.concluido_em).toLocaleDateString("pt-BR") : ""}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
